
import styles from './index.module.scss'
import Utils from '@utils/utils'
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Image, Popover } from 'antd'
import { IMAGE_TYPE, TYPETITLEMAP, CLOTH_COLOR_TYPE, VIDEO_ORIENTATION, GENERATE_MODE, POSE_FANTASY_MODE, RELIGHT_MODE, INPUT_IMAGE_TYPE, MODEL_PROVIDER, SMART_DETAIL_LANG_LABEL_MAP, SMART_DETAIL_PLATFORM_LABEL_MAP } from '@utils/CONST'
import Iconfont from '@utils/Iconfont';
import { LoadingOutlined } from '@ant-design/icons';

const ProjectDetailGroupsTitle = (props) => {
    const { item, imageType } = props;
    const getGenerateModeLabel = (mode, modelProvider) => {
        if (imageType == IMAGE_TYPE.NECKLACE_TRYON) {
            return mode == GENERATE_MODE.HQ ? '全能模型·高品质4K' : '全能模型·标准2K'
        }
        const isSotaModel = modelProvider == MODEL_PROVIDER.SOTA || modelProvider?.toLowerCase?.() == 'sota'
        if (isSotaModel) return mode == GENERATE_MODE.HQ ? '高品质模式4K' : '标准模式2K'
        return mode == GENERATE_MODE.HQ ? '高品质模式' : '标准模式'
    }
    const getCreativeImageModeLabel = (mode) => {
        return mode == GENERATE_MODE.HQ ? '4K' : '2K'
    }
    const formatModelProvider = (value) => {
        if (!value) return ''
        if (value == MODEL_PROVIDER.SOTA || value.toLowerCase?.() == 'sota') return '全能模型'
        if (value == MODEL_PROVIDER.ARCMUSE || value.toLowerCase?.() == 'arcmuse') return 'ArcMuse'
        return value
    }
    const getSmartDetailPlatformLabel = (value) => {
        if (!value) return ''
        return SMART_DETAIL_PLATFORM_LABEL_MAP?.[value] || value
    }
    const getSmartDetailLangLabel = (value) => {
        if (!value) return ''
        return SMART_DETAIL_LANG_LABEL_MAP?.[value] || value
    }
    const getAspectRatioLabel = (value) => {
        if (!value) return '原比例'
        return value === 'smart' ? '智能' : value
    }
    const mainTitle = (
        <span className={styles.mainTitle}>{
            (imageType == IMAGE_TYPE.MODEL && item.keepBkg && !item.keepPose) ?
                '换模特' : (imageType == IMAGE_TYPE.MODEL && !item.keepBkg && item.keepPose) ?
                    '换背景' : (imageType == IMAGE_TYPE.MODEL && !item.keepBkg && !item.keepPose) ?
                        '换模特换背景' : (imageType == IMAGE_TYPE.BACKGROUND) ? '换背景' :
                            (imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR) ? '自由换色' :
                                (imageType == IMAGE_TYPE.CLOTH_RECOLOR && item.mode == CLOTH_COLOR_TYPE.SIM_RECOLOR) ? '同款换色' :
                                    TYPETITLEMAP[imageType]
        }</span>
    )

    const videoDesc = useMemo(() => {
        return item?.prompt || (
            imageType == IMAGE_TYPE.FUSION_WEAR
                ? <LoadingOutlined />
                : null
        )
    }, [item, imageType])

    const videoTextRef = useRef(null)
    const [videoOverflow, setVideoOverflow] = useState(false)
    const [videoPopoverOpen, setVideoPopoverOpen] = useState(false)

    useEffect(() => {
        const el = videoTextRef.current
        if (!el) return
        setVideoOverflow(el.scrollHeight > el.clientHeight + 1)
    }, [videoDesc])

    const creativeImageList = useMemo(() => {
        return (item?.refImages || item?.matchImages || []).filter(Boolean)
    }, [item?.refImages, item?.matchImages])

    const creativeImagePreviewList = useMemo(() => {
        if (creativeImageList.length <= 4) return creativeImageList
        return creativeImageList.slice(0, 4)
    }, [creativeImageList])

    const videoTitle = (
        <div className={styles.videoTitle}>
            <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.inputImage)} />
            <div className={styles.videoTextWrap}>
                <div className={styles.textOnlyWrap}>
                    <span ref={videoTextRef} className={styles.videoText}><span style={{ fontWeight: 'bold', color: '#000' }}>动作模仿</span> {videoDesc}</span>
                    {videoOverflow && (
                        <Popover
                            open={videoPopoverOpen}
                            onOpenChange={setVideoPopoverOpen}
                            trigger="hover"
                            placement="bottomRight"
                            content={<div className={styles.videoPopoverContent}>{videoDesc}</div>}
                        >
                            <span className={styles.viewAll}>查看全部</span>
                        </Popover>
                    )}
                </div>

                <p className={styles.detail}>
                    <span>{item?.createdTime}</span>
                    <span>{(item?.orientation === VIDEO_ORIENTATION.REF || !item?.orientation) ? '与参考视频一致' : '与模特图一致'}</span>
                    <span>{getGenerateModeLabel(item?.mode, item?.modelProvider || item?.attr?.modelProvider)}</span>
                </p>
            </div>
        </div>
    )

    const videoTitle2 = (
        <div className={styles.videoTitle}>
            <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.inputImage)} />
            {item.imageTail && <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.imageTail)} />}
            <div className={styles.videoTextWrap}>
                <div className={styles.textOnlyWrap}>
                    <span ref={videoTextRef} className={styles.videoText}><span style={{ fontWeight: 'bold', color: '#000' }}>图生视频</span> {videoDesc}</span>
                    {videoOverflow && (
                        <Popover
                            open={videoPopoverOpen}
                            onOpenChange={setVideoPopoverOpen}
                            trigger="hover"
                            placement="bottomRight"
                            content={<div className={styles.videoPopoverContent}>{videoDesc}</div>}
                        >
                            <span className={styles.viewAll}>查看全部</span>
                        </Popover>
                    )}
                </div>

                <p className={styles.detail}>
                    <span>{item?.createdTime}</span>
                    <span>{item?.duration == 5 ? '5秒' : '10秒'}</span>
                    <span>{getGenerateModeLabel(item?.mode, item?.modelProvider || item?.attr?.modelProvider)}</span>
                </p>
            </div>
        </div>
    )

    const fusionWearTitle = (
        <div className={styles.videoTitle}>
            {
                item?.matchImages?.map((img, index) => (
                    <Image className={styles.thumbnail} src={Utils.getImgThumbnail(img?.url)} />
                ))
            }
            {item?.modelImage?.url && <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.modelImage?.url)} />}
            <div className={styles.videoTextWrap}>
                <div className={styles.textOnlyWrap}>
                    <span ref={videoTextRef} className={styles.videoText}>{videoDesc}</span>
                    {videoOverflow && (
                        <Popover
                            open={videoPopoverOpen}
                            onOpenChange={setVideoPopoverOpen}
                            trigger="hover"
                            placement="bottomRight"
                            content={<div className={styles.videoPopoverContent}>{videoDesc}</div>}
                        >
                            <span className={styles.viewAll}>查看全部</span>
                        </Popover>
                    )}
                </div>

                <p className={styles.detail}>
                    <span>{item?.createdTime}</span>
                    <span>{getGenerateModeLabel(item?.mode, item?.modelProvider || item?.attr?.modelProvider)}</span>
                </p>
            </div>
        </div>
    )

    const smartDetailRefImages = useMemo(() => {
        return (item?.refImages || []).filter(img => img?.url)
    }, [item?.refImages])
    const smartDetailRefTemplate = item?.refTemplate?.url || item?.refTemplate?.image || item?.refTemplate?.cover || item?.attr?.refTemplate?.url || item?.attr?.refTemplate?.image || item?.attr?.refTemplate?.cover || item?.refTemplate || item?.attr?.refTemplate
    const smartDetailAspectRatio = item?.aspectRatio || item?.attr?.aspectRatio
    const smartDetailPlatform = getSmartDetailPlatformLabel(item?.ecPlatform || item?.attr?.ecPlatform)
    const smartDetailLang = getSmartDetailLangLabel(item?.lang || item?.attr?.lang)
    const creativeAspectRatio = item?.aspectRatio || item?.attr?.aspectRatio

    const smartDetailTitle = (
        <div className={styles.videoTitle}>
            {
                smartDetailRefImages.map((img, index) => (
                    <Image key={`${img?.url || index}-${index}`} className={styles.thumbnail} src={Utils.getImgThumbnail(img?.url)} />
                ))
            }
            {smartDetailRefTemplate && (
                <React.Fragment>
                    <Image className={styles.thumbnail} src={Utils.getImgThumbnail(smartDetailRefTemplate)} />
                </React.Fragment>
            )}
            <div className={styles.videoTextWrap}>
                <div className={styles.textOnlyWrap}>
                    <span ref={videoTextRef} className={styles.videoText}>{videoDesc}</span>
                    {videoOverflow && (
                        <Popover
                            open={videoPopoverOpen}
                            onOpenChange={setVideoPopoverOpen}
                            trigger="hover"
                            placement="bottomRight"
                            content={<div className={styles.videoPopoverContent}>{videoDesc}</div>}
                        >
                            <span className={styles.viewAll}>查看全部</span>
                        </Popover>
                    )}
                </div>

                <p className={styles.detail}>
                    <span>{item?.createdTime}</span>
                    {item?.mode && <span>{item?.mode}</span>}
                    {smartDetailAspectRatio && <span>{getAspectRatioLabel(smartDetailAspectRatio)}</span>}
                    {smartDetailPlatform && <span>{smartDetailPlatform}</span>}
                    {smartDetailLang && <span>{smartDetailLang}</span>}
                </p>
            </div>
        </div>
    )

    const creativeImageGenTitle = (
        <div className={styles.videoTitle}>
            {
                creativeImagePreviewList.map((img, index) => {
                    const total = creativeImageList.length
                    const isLastPreview = index === creativeImagePreviewList.length - 1
                    const shouldShowCount = total > 4 && isLastPreview

                    return (
                        <div
                            key={`${img?.url || img || index}-${index}`}
                            className={styles.creativeThumbnailWrap}
                        >
                            <Image
                                className={styles.thumbnail}
                                src={Utils.getImgThumbnail(img?.url || img)}
                            />
                            {shouldShowCount && (
                                <div className={styles.creativeThumbnailOverlay}>
                                    <span className={styles.creativeThumbnailCount}>{total}+</span>
                                </div>
                            )}
                        </div>
                    )
                })
            }
            <div className={styles.videoTextWrap}>
                <div className={styles.textOnlyWrap}>
                    <span ref={videoTextRef} className={styles.videoText}>{videoDesc}</span>
                    {videoOverflow && (
                        <Popover
                            open={videoPopoverOpen}
                            onOpenChange={setVideoPopoverOpen}
                            trigger="hover"
                            placement="bottomRight"
                            content={<div className={styles.videoPopoverContent}>{videoDesc}</div>}
                        >
                            <span className={styles.viewAll}>查看全部</span>
                        </Popover>
                    )}
                </div>

                <p className={styles.detail}>
                    <span>{item?.createdTime}</span>
                    {item?.mode && <span>{getCreativeImageModeLabel(item?.mode)}</span>}
                    {creativeAspectRatio && <span>{getAspectRatioLabel(creativeAspectRatio)}</span>}
                </p>
            </div>
        </div>
    )

    const personTitle = (!item.keepPose && item?.person?.url) &&
        <React.Fragment>
            <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.person?.url)} />
            <span className={styles.title}>
                {
                    item?.person?.custom ? "自定义模特" :
                        item?.person?.title?.split("-").pop()
                }
            </span>
        </React.Fragment>

    const bkgTitle = (!item.keepBkg && item?.background?.url) &&
        <React.Fragment>
            <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.background?.url)} />
            <span className={styles.title}>
                {
                    item?.background?.custom ? "自定义背景" :
                        item?.background?.title?.split("-").pop()
                }
            </span>
        </React.Fragment>
    const relightModeTitle = (item.relightMode && item.relight > 0) &&
        <span className={styles.title}>
            {
                item?.relightMode === RELIGHT_MODE.SKIN ? "标准模式" :
                    item?.relightMode === RELIGHT_MODE.PORTRAIT ? "人像模式" : "反光板模式"
            }
        </span>

    const keepHatTitle = (item?.keepHat == 1) &&
        <span className={styles.title}>保留头饰</span>

    const poseTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.pose?.url)} />
        <span className={styles.title}>
            {item?.pose?.custom ? "自定义参考图" : '参考图'}
        </span>
    </React.Fragment>

    const shoesTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.shoesRef?.url)} />
        <span className={styles.title}>
            {item?.shoesRef?.custom ? "自定义参考图" : '预设参考图'}
        </span>
    </React.Fragment>

    const reColorTitle = <React.Fragment>
        <span className={styles.colorBox} style={{ backgroundColor: item.color }} ></span>
        <span className={styles.title}>{item.color}</span>
    </React.Fragment>

    const simReColorTitle = <React.Fragment>
        {
            item.clothes?.split(',').map((url) => (
                <Image style={{ marginRight: 5 }} className={styles.thumbnail} src={Utils.getImgThumbnail(url)} />
            ))
        }
        <span className={styles.title}>{item.mode == INPUT_IMAGE_TYPE.MATERIAL ? "面料图" : "衣服平铺图"}</span>
    </React.Fragment>

    const commidityTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.background?.url)} />
        <span className={styles.title}>
            {
                item?.background?.custom ? "自定义背景" :
                    item?.background?.title?.split("-").pop()
            }
        </span>
    </React.Fragment>

    const modelTitle = <React.Fragment>
        <Iconfont type={item?.mode == 'hq' ? "icon-hdOutlined" : "icon-stdOutlined"} className={styles.Icon} />
        <span className={styles.title}>
            {getGenerateModeLabel(item?.mode, item?.modelProvider || item?.attr?.modelProvider)}
        </span>
    </React.Fragment>

    const hdModelTitle = <React.Fragment>
        <Iconfont type={item?.hdMode == 'hq' ? "icon-hdOutlined" : "icon-stdOutlined"} className={styles.Icon} />
        <span className={styles.title}>
            {getGenerateModeLabel(item?.hdMode, item?.modelProvider || item?.attr?.modelProvider)}
        </span>
    </React.Fragment>

    const modelProviderValue = formatModelProvider(item?.modelProvider || item?.attr?.modelProvider)
    const isArcMuseModel = (item?.modelProvider || item?.attr?.modelProvider) == MODEL_PROVIDER.ARCMUSE || (item?.modelProvider || item?.attr?.modelProvider)?.toLowerCase?.() == 'arcmuse'
    const modelProviderTitle = (imageType == IMAGE_TYPE.CLOTHES || imageType == IMAGE_TYPE.MODEL) && modelProviderValue && <React.Fragment>
        <span className={styles.title}>{modelProviderValue}</span>
    </React.Fragment>
    const clothesAspectRatioValue = imageType == IMAGE_TYPE.CLOTHES ? (item?.aspectRatio ?? item?.attr?.aspectRatio ?? '') : null
    const isSotaModel = (item?.modelProvider || item?.attr?.modelProvider) == MODEL_PROVIDER.SOTA || (item?.modelProvider || item?.attr?.modelProvider)?.toLowerCase?.() == 'sota'
    const aspectRatioTitle = imageType == IMAGE_TYPE.CLOTHES && isSotaModel && <React.Fragment>
        <span className={styles.title}>{getAspectRatioLabel(clothesAspectRatioValue)}</span>
    </React.Fragment>

    const poseTryonTitle = (
        item.mode == POSE_FANTASY_MODE.REFERENCEMODE ?
            <React.Fragment>
                <span className={styles.title}>参考图模式</span>
                <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.poseRef?.url)} />
                <span className={styles.title}>
                    {
                        item?.poseRef?.custom ? "自定义参考图" :
                            '预设参考图'
                    }
                </span>
            </React.Fragment>
            : <div className={styles.videoTitle}>
                <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.inputImage)} />
                {item.imageTail && <Image className={styles.thumbnail} src={Utils.getImgThumbnail(item?.imageTail)} />}
                <div className={styles.videoTextWrap}>
                    <div className={styles.textOnlyWrap}>
                        <span ref={videoTextRef} className={styles.videoText}>{videoDesc}</span>
                        {videoOverflow && (
                            <Popover
                                open={videoPopoverOpen}
                                onOpenChange={setVideoPopoverOpen}
                                trigger="hover"
                                placement="bottomRight"
                                content={<div className={styles.videoPopoverContent}>{videoDesc}</div>}
                            >
                                <span className={styles.viewAll}>查看全部</span>
                            </Popover>
                        )}
                    </div>

                    <p className={styles.detail}>
                        <span>{item?.createdTime}</span>
                        <span>自由模式</span>
                    </p>
                </div>
            </div>
    )

    const glassesTryonTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail((imageType == IMAGE_TYPE.NECKLACE_TRYON ? item?.jewelryRef?.url : item?.glassesRef?.url) || item?.glassesRef?.url)} />
        <span className={styles.title}>
            {
                ((imageType == IMAGE_TYPE.NECKLACE_TRYON ? item?.jewelryRef?.custom : item?.glassesRef?.custom) ?? item?.glassesRef?.custom) ? "自定义参考图" : '预设参考图'
            }
        </span>
    </React.Fragment>

    const simTryonRef = item?.refImage || item?.poseRef
    const simTryonTitle = <React.Fragment>
        <Image className={styles.thumbnail} src={Utils.getImgThumbnail(simTryonRef?.url)} />
        <span className={styles.title}>
            {imageType == IMAGE_TYPE.FLATLAY3D ? '3D参考图' : (simTryonRef?.custom ? "自定义参考图" : '预设参考图')}
        </span>
    </React.Fragment>

    const resolutionAlignTitle = item?.resolutionAlign && <React.Fragment>
        <span className={styles.title}>
            {item?.resolutionAlign == 'bkg' ? "参考图比例" : item?.resolutionAlign == 'input' ? "上传图比例" : null}
        </span>
    </React.Fragment>

    return (
        <div className={styles.ProjectDetailGroupsTitle}>
            {
                imageType == IMAGE_TYPE.MODEL_VIDEO ? videoTitle :
                    imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ? videoTitle2 :
                        imageType == IMAGE_TYPE.FUSION_WEAR ? fusionWearTitle :
                            imageType == IMAGE_TYPE.SMART_DETAILA_PAGE ? smartDetailTitle :
                            imageType == IMAGE_TYPE.CREATIVE_IMAGE_GEN ? creativeImageGenTitle :
                            mainTitle}
            {imageType == IMAGE_TYPE.CLOTHES && poseTitle}
            {(imageType == IMAGE_TYPE.CLOTHES || imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.GRASS_PLANT) && personTitle}
            {(imageType == IMAGE_TYPE.CLOTHES || imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND || imageType == IMAGE_TYPE.GRASS_PLANT) && bkgTitle}
            {imageType == IMAGE_TYPE.COMMODITYRECOLOR && reColorTitle}
            {imageType == IMAGE_TYPE.CLOTH_RECOLOR && (item.mode == CLOTH_COLOR_TYPE.CLOTH_RECOLOR ? reColorTitle : simReColorTitle)}
            {imageType == IMAGE_TYPE.SHOES && shoesTitle}
            {imageType == IMAGE_TYPE.COMMODITY && commidityTitle}
            {(imageType == IMAGE_TYPE.POSE_TRYON) && poseTryonTitle}
            {(imageType == IMAGE_TYPE.GLASSES_TRYON || imageType == IMAGE_TYPE.NECKLACE_TRYON) && glassesTryonTitle}
            {(
                imageType == IMAGE_TYPE.CLOTHES ||
                (imageType == IMAGE_TYPE.MODEL && !isArcMuseModel) ||
                imageType == IMAGE_TYPE.SHOES ||
                imageType == IMAGE_TYPE.GRASS_PLANT ||
                imageType == IMAGE_TYPE.GLASSES_TRYON ||
                imageType == IMAGE_TYPE.NECKLACE_TRYON ||
                imageType == IMAGE_TYPE.COMMODITY
            ) && modelTitle}
            {modelProviderTitle}
            {aspectRatioTitle}
            {(imageType == IMAGE_TYPE.COMMODITYRECOLOR ||
                (imageType == IMAGE_TYPE.POSE_TRYON && item?.mode == POSE_FANTASY_MODE.REFERENCEMODE)) && hdModelTitle}
            {(imageType == IMAGE_TYPE.SIM_TRYON || imageType == IMAGE_TYPE.FLATLAY3D) && simTryonTitle}
            {(imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND) && resolutionAlignTitle}
            {(imageType == IMAGE_TYPE.MODEL || imageType == IMAGE_TYPE.BACKGROUND) && relightModeTitle}
            {imageType == IMAGE_TYPE.MODEL && keepHatTitle}
        </div>
    )
}

export default ProjectDetailGroupsTitle
